import { render, staticRenderFns } from "./checkApiVersion.vue?vue&type=template&id=14c39b00&"
import script from "./checkApiVersion.vue?vue&type=script&lang=js&"
export * from "./checkApiVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports